import { __decorate } from "tslib";
import { html, nothing } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import styles from './value-props.scss.js';
/**
 * cipublic-value-props
 *
 * @slot propitem - `cipublic-prop-item`
 * @slot heading
 * @slot content
 * @slot subHeading
 */
export class ValueProps extends CipublicElement {
    constructor() {
        super(...arguments);
        /**
         * Props displayed per row (1 | 2 | 3 | 4)
         */
        this.propsPerRow = 1;
        /**
         * The style of Value props component
         */
        this.variant = 'basic';
        /**
         * Hid or show heading section
         */
        this.hideHeading = false;
    }
    static get styles() {
        return [styles];
    }
    render() {
        return html `${!this.hideHeading
            ? html `<div class="header-wrapper"><slot name="heading"></slot><slot name="content"></slot><slot name="sub-heading"></slot></div>`
            : html `${nothing}`} ${this.variant === 'with-image'
            ? html `<div class="items-2"><div><slot name="prop-item"></slot></div><slot name="image"></slot></div>`
            : html `<div class="items-${this.propsPerRow}"><slot name="prop-item"></slot></div>`}`;
    }
}
__decorate([
    property({ type: Number, reflect: true })
], ValueProps.prototype, "propsPerRow", void 0);
__decorate([
    property({ reflect: true })
], ValueProps.prototype, "variant", void 0);
__decorate([
    property({ reflect: true, type: Boolean, attribute: 'hide-heading' })
], ValueProps.prototype, "hideHeading", void 0);
//# sourceMappingURL=value-props.js.map